/**
 * AccessCodeGate — requires the site access code before any admin route
 * except /health. Unlock is stored in sessionStorage for the tab.
 */
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AccessCodePage } from '../pages/AccessCodePage';
import { persistAdminAccessUnlock, readAdminAccessUnlock } from '../lib/accessCode';

export function AccessCodeGate() {
  const [unlocked, setUnlocked] = useState(readAdminAccessUnlock);

  if (!unlocked) {
    return (
      <AccessCodePage
        onUnlock={() => {
          persistAdminAccessUnlock();
          setUnlocked(true);
        }}
      />
    );
  }

  return <Outlet />;
}
